const QuickCart = {
  el: $(".quick-cart"),
  qtyThrottle: undefined,

  init() {
    QuickCart.events();
    QuickCart.quantityEvents();
    QuickCart.progressBar();
  },

  /**
   * Open QuickCart
   **/
  open() {
    QuickCart.el.addClass("quick-cart--open");
    $("html").addClass("no-scroll");
  },

  /**
   * Close QuickCart
   **/
  close() {
    QuickCart.el.removeClass("quick-cart--open");
    $("html").removeClass("no-scroll");
  },

  /**
   * Loaded QuickCart
   **/
  loaded() {
    QuickCart.el.addClass("quick-cart--loaded");
  },

  /**
   * QuickCart functionality
   **/
  events() {
    $(".cart-btn:not(.cart-page)").on("click", function (e) {
      e.preventDefault();

      switch (true) {
        case QuickCart.el.hasClass("quick-cart--open"):
          QuickCart.close();
          break;

        case QuickCart.el.hasClass("quick-cart--loaded"):
          QuickCart.open();
          break;

        default:
          QuickCart.render();
          break;
      }
    });

    QuickCart.el.on("click", ".quick-cart__close", function () {
      QuickCart.close();
    });

    $(document).keyup(function (e) {
      if (QuickCart.el.hasClass("quick-cart--loaded")) {
        if (e.keyCode === 27) {
          QuickCart.close();
        }
      }
    });

    $(document).mouseup(function (e) {
      if (QuickCart.el.hasClass("quick-cart--loaded")) {
        var container = QuickCart.el.find(".quick-cart__inner");

        // if the target of the click isn't the container nor a descendant of the container
        if (!container.is(e.target) && container.has(e.target).length === 0) {
          QuickCart.close();
        }
      }
    });

    // Coupon handling
    $(".quick-cart").on("click", "#apply_coupon", function (e) {
      e.preventDefault();
      const buttonEl = $(this);

      const couponEl = $("#coupon_code");
      const couponCode = couponEl.val();

      if (!couponCode || couponCode.length < 1) {
        couponEl.addClass("error");
        $(".coupon-error").text(translations.coupon_empty);
        return;
      }

      buttonEl.attr("disabled", true);
      buttonEl.addClass("disabled");
      buttonEl.find(".btn-loader").removeClass("hidden");

      $.ajax({
        type: "POST",
        url: ajaxurl,
        data: {
          action: "handle_coupon",
          type: "add",
          code: couponCode,
        },
      }).done((resp) => {
        if (resp.content) {
          QuickCart.el.html(resp.content);
        }
        if (resp.message) {
          $(".coupon-error").text(resp.message);
        }

        buttonEl.removeAttr("disabled");
        buttonEl.removeClass("disabled");
        buttonEl.find(".btn-loader").addClass("hidden");
      });
    });

    $(".quick-cart").on("click", ".remove-coupon", function (e) {
      e.preventDefault();
      const buttonEl = $(this);

      const couponCode = $(this).data("coupon");

      buttonEl.attr("disabled", true);
      buttonEl.addClass("disabled");
      buttonEl.find(".btn-loader").removeClass("hidden");

      $.ajax({
        type: "POST",
        url: ajaxurl,
        data: {
          action: "handle_coupon",
          type: "remove",
          code: couponCode,
        },
      }).done((resp) => {
        // console.log(resp.content);
        if (resp.content) {
          QuickCart.el.html(resp.content);
        }
        if (resp.message) {
          $(".coupon-error").text(resp.message);
        }

        buttonEl.removeAttr("disabled");
        buttonEl.removeClass("disabled");
        buttonEl.find(".btn-loader").addClass("hidden");
      });
    });
  },

  quantityEvents() {
    QuickCart.el.on("click", ".quantity__button--up", function (e) {
      const inputEl = $(this).siblings("input");

      QuickCart.handleQtyInput(inputEl, "add");

      if (QuickCart.qtyThrottle) {
        return;
      }

      QuickCart.qtyThrottle = setTimeout(() => {
        QuickCart.changeQuantity(inputEl, "add");
        QuickCart.qtyThrottle = undefined;
      }, 1000);
    });

    QuickCart.el.on("click", ".quantity__button--down", function (e) {
      const inputEl = $(this).siblings("input");

      QuickCart.handleQtyInput(inputEl, "remove");

      if (QuickCart.qtyThrottle) {
        return;
      }

      QuickCart.qtyThrottle = setTimeout(() => {
        QuickCart.changeQuantity(inputEl, "remove");
        QuickCart.qtyThrottle = undefined;
      }, 1000);
    });
  },

  handleQtyInput(inputEl, type) {
    let product_qty = parseInt(inputEl.val());

    if (type === "add") {
      if (inputEl.attr("max") < product_qty + 1) {
        return;
      }
      product_qty++;
    } else if (type === "remove") {
      if (product_qty <= 1) {
        return;
      }
      product_qty--;
    }

    inputEl.val(product_qty);
  },

  changeQuantity(inputEl) {
    QuickCart.el.addClass("quick-cart--loading");

    const product_key = inputEl
      .closest("[data-product-key]")
      .attr("data-product-key");

    const product_qty = parseInt(inputEl.val());

    $.ajax({
      type: "POST",
      url: ajaxurl,
      dataType: "JSON",
      data: {
        action: "handle_change_quantity",
        product_key,
        product_qty,
      },
    }).done((resp) => {
      QuickCart.setCart(resp);
      QuickCart.el.removeClass("quick-cart--loading");
    });
  },

  /**
   * Render quickcart
   **/
  render() {
    QuickCart.open();
    QuickCart.el.html(
      '<div class="quick-cart-loader"><div class="spinner"></div></div>'
    );

    $.ajax({
      type: "POST",
      url: ajaxurl,
      dataType: "JSON",
      data: {
        action: "render_quick_cart",
      },
    }).done((response) => {
      if (response) {
        QuickCart.loaded();
        QuickCart.progressBar();
        QuickCart.el.html(response);
      } else {
        QuickCart.close();
      }
    });
  },

  /**
   * Set cart item values
   */
  setCart(cart) {
    for (let index = 0; index < cart.items.length; index++) {
      const item = cart.items[index];

      const cartItemEl = $(`[data-product-key="${item.key}"]`);

      cartItemEl.find(".quantity__input").val(item.quantity);
      cartItemEl.find(".cart-item-price").html(item.price);
      if (cartItemEl.find(".cart-item-price-unit").length) {
        cartItemEl.find(".cart-item-price-unit").html(item.price_unit);
      }
      if (cartItemEl.find(".cart-item-price-old").length) {
        cartItemEl.find(".cart-item-price-old").html(item.regular_price);
      }
    }


    if (cart.hasOwnProperty("fee_text")) {
      $(".quick-cart-fee-no-vat-text").html(cart.fee_text);
      $(".quick-cart-fee-no-vat").html(cart.fee);
      $(".quick-cart-fee-wrap").show();
    } else {
      $(".quick-cart-fee-wrap").hide();
    }

    $(".quick-cart__body .missing_progress").html(cart.progress_bar.missing.toFixed(2));
    $(".quick-cart__body .progress .progress__value-current").html(cart.progress_bar.total.toFixed(2) + ' €');
    $(".quick-cart__body .progress .progress__value-goal").html('/' + cart.progress_bar.needs.toFixed(2) + ' €');
    $(".quick-cart__body .progress .progress__bar").attr('data-progress', cart.progress_bar.progress );

    if(cart.progress_bar.progress === 1) {
      $(".quick-cart__body .progress-message").hide();
      QuickCart.progressBar();
    } else {
      QuickCart.progressBar();
      $(".quick-cart__body .progress, .quick-cart__body .progress-message").show();
    }

    $(".quick-cart-vat").html(cart.tax);
    $(".quick-cart-total").html(cart.total);
  },

  progressBar() {
    const quickCart = document.querySelector('.quick-cart');
    if (!quickCart) {
      return;
    }

    const observer = new MutationObserver(() => {
      if (quickCart.classList.contains('quick-cart--loaded')) {
        const bar = document.querySelector('.quick-cart .progress__bar');

        if (!bar) {
          return;
        }

        observer.disconnect();
        let progress = parseFloat(bar.getAttribute("data-progress")) * 100;
        bar.style.width = `${progress}%`;
      }
    });

    observer.observe(quickCart, { attributes: true });
  }

};

export default QuickCart;
